import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "page" }
const _hoisted_2 = { class: "container-fluid breadcrumbs d-none d-md-block" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { "aria-label": "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb" }
const _hoisted_8 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_9 = {
  id: "main",
  class: ""
}
const _hoisted_10 = { class: "container px-xs-0 beratung" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "login-heading" }
const _hoisted_13 = { class: "row login-content" }
const _hoisted_14 = {
  class: "mb-4",
  style: {"margin-bottom":"1rem !important"}
}
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-12 col-lg-4 mb-5 mb-lg-0" }
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = {
  class: "form-label",
  for: "username"
}
const _hoisted_19 = { class: "d-flex mt-2" }
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = {
  class: "form-label",
  for: "password"
}
const _hoisted_22 = { class: "pw-input--wrapper" }
const _hoisted_23 = ["type", "name"]
const _hoisted_24 = ["title", "aria-label"]
const _hoisted_25 = {
  key: 0,
  id: "passwordHelp",
  class: "form-text alert alert-danger mt-3"
}
const _hoisted_26 = {
  class: "mb-4",
  style: {"margin-top":"0.8rem"}
}
const _hoisted_27 = { class: "mb-4" }
const _hoisted_28 = {
  class: "form-label",
  for: "mail"
}
const _hoisted_29 = ["name"]
const _hoisted_30 = {
  key: 0,
  class: "form-text alert alert-danger"
}
const _hoisted_31 = { class: "mb-4" }
const _hoisted_32 = {
  class: "form-label",
  for: "phone"
}
const _hoisted_33 = ["name"]
const _hoisted_34 = {
  key: 0,
  class: "form-text alert alert-danger"
}
const _hoisted_35 = {
  class: "form-check",
  style: {"margin-top":"0.5rem !important"}
}
const _hoisted_36 = {
  for: "accept",
  style: {"margin-left":"0.3rem"},
  class: "text-black"
}
const _hoisted_37 = ["href"]
const _hoisted_38 = ["href"]
const _hoisted_39 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_40 = {
  key: 0,
  class: "form-text alert alert-danger"
}
const _hoisted_41 = {
  key: 1,
  class: "form-text alert alert-success"
}
const _hoisted_42 = { class: "my-3" }
const _hoisted_43 = { class: "col offset-lg-1" }
const _hoisted_44 = {
  class: "mb-4",
  style: {"margin-top":"0.5rem","margin-bottom":"0.8rem !important"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("nav", _hoisted_6, [
              _createElementVNode("ol", _hoisted_7, [
                _cache[11] || (_cache[11] = _createElementVNode("li", { class: "breadcrumb-item" }, [
                  _createElementVNode("a", { href: "#" }, "Home")
                ], -1)),
                _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t('views.login.breadcrumbpage')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[12] || (_cache[12] = _createElementVNode("i", {
              "aria-hidden": "true",
              class: "icon icon--user-solid"
            }, null, -1)),
            _createElementVNode("div", null, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t('views.login.breadcrumbpage')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.$t('views.register.registertext')), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('views.login.username')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                  id: "username"
                }, null, 512), [
                  [_vModelText, _ctx.username]
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", {
                    class: "icon icon-alert_info",
                    style: {"margin-right":"5px"},
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createElementVNode("small", null, _toDisplayString(_ctx.$t('views.register.validCharacters')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('views.login.password')), 1),
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.passwordFieldType,
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                    id: "password",
                    name: _ctx.generateRandomName('password'),
                    "aria-describedby": "passwordHelp",
                    onFocus: _cache[2] || (_cache[2] = ($event: any) => {_ctx.showPasswordHelp = ''; _ctx.passwordError = '';}),
                    autocomplete: "off"
                  }, null, 40, _hoisted_23), [
                    [_vModelDynamic, _ctx.password]
                  ]),
                  _createElementVNode("i", {
                    "data-target": "password",
                    class: _normalizeClass([_ctx.passwordFieldType === 'password' ? 'onb-visible--on' : 'onb-visible--off', "icon pw-input--switch"]),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args))),
                    title: _ctx.passwordFieldType === 'password' ? _ctx.$t('views.login.showpw') : _ctx.$t('views.login.hidepw'),
                    "aria-label": _ctx.passwordFieldType === 'password' ? _ctx.$t('views.login.showpw') : _ctx.$t('views.login.hidepw')
                  }, null, 10, _hoisted_24)
                ]),
                (_ctx.showPasswordHelp)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$t('views.register.pwhint')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_26, [
                  _cache[14] || (_cache[14] = _createElementVNode("i", {
                    "aria-hidden": "true",
                    class: "icon icon--warning me-2"
                  }, null, -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('views.register.pwnoreset')), 1)
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.register.registernote')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.register.nonotifications')), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('views.register.email')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event)),
                  id: "email",
                  autocomplete: "off",
                  name: _ctx.generateRandomName('email'),
                  onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.mailHasFocus = true)),
                  onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mailHasFocus = false))
                }, null, 40, _hoisted_29), [
                  [_vModelText, _ctx.email]
                ]),
                (_ctx.email != '' && !_ctx.mailHasFocus && !_ctx.isValidEmail(_ctx.email))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.$t('views.register.emailinvalid')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('views.register.phone')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.phone) = $event)),
                  id: "phone",
                  autocomplete: "off",
                  name: _ctx.generateRandomName('phone')
                }, null, 8, _hoisted_33), [
                  [_vModelText, _ctx.phone]
                ]),
                (_ctx.phone != '' && !_ctx.isValidPhone(_ctx.phone))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.$t('views.register.phoneinvalid')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  style: {"margin-top":"0.4rem !important","margin-left":"-1.2rem"},
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.acceptTerms) = $event)),
                  id: "accept",
                  value: "accept"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.acceptTerms]
                ]),
                _createElementVNode("label", _hoisted_36, [
                  _createTextVNode(_toDisplayString(_ctx.$t('views.register.acceptance')) + " ", 1),
                  _createElementVNode("a", {
                    href: _ctx.getNutzungLink()
                  }, _toDisplayString(_ctx.$t('views.register.acceptancelink')), 9, _hoisted_37),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('views.register.and')) + " ", 1),
                  _createElementVNode("a", {
                    href: _ctx.getDsvgoLink()
                  }, _toDisplayString(_ctx.$t('views.register.dsgvo')), 9, _hoisted_38),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('views.register.agreeTo')), 1)
                ]),
                (_ctx.error != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true)
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("input", {
                id: "captchaToken",
                type: "hidden",
                name: "captcha-token",
                value: ""
              }, null, -1)),
              _createElementVNode("button", {
                class: "btn btn-primary-custom mb-4",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)))
              }, _toDisplayString(_ctx.$t('views.register.register')), 1),
              (_ctx.passwordError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.$t('views.register.wrongpw')), 1))
                : _createCommentVNode("", true),
              (_ctx.success != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.success), 1))
                : _createCommentVNode("", true),
              _createElementVNode("h4", _hoisted_42, _toDisplayString(_ctx.$t('views.register.infotext')), 1),
              _createElementVNode("button", {
                class: "btn btn-primary-custom",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.navigateToLogin && _ctx.navigateToLogin(...args)))
              }, _toDisplayString(_ctx.$t('views.register.tologin')), 1)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("h4", _hoisted_44, _toDisplayString(_ctx.$t('views.register.help')), 1),
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('views.register.choosename')) + " ", 1),
                _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('views.register.nameinfo')), 1)
              ]),
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('views.register.nosave')), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}